<template>
    <div class="flex h-screen overflow-hidden">
        <Sidebar />

        <div class="flex flex-col flex-1 min-w-0">
            <Topbar />

            <main class="flex-1 overflow-auto p-4 md:p-6 text-sm bg-slate-100 dark:bg-[#0a0f1a]">
                <router-view />
            </main>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { onMounted } from 'vue'

    import Sidebar from '@/layouts/components/Sidebar.vue'
    import Topbar from '@/layouts/components/Topbar.vue'
    import { useAppStore } from '@/stores/app'
    import { useFetchStore } from '@/stores/fetch'

    const appStore   = useAppStore()
    const fetchStore = useFetchStore()

    onMounted(async () => {
        if (!appStore.isLoggedIn() || appStore.userData) return

        const { statusCode, data } = await fetchStore.fetch('/me').get().json()
        if (statusCode.value === 200) appStore.userData = data.value as never
    })
</script>
